<template>
  <div v-if="product">

    <item-history
      :active.sync="itemHistory.active"
      :product="itemHistory.product"
      :type.sync="itemHistory.type"
      v-if="product.id"
    ></item-history>


    <div class="flex flex-wrap -mx-2">
      <div class="w-full lg:w-1/3 xl:w-1/4 px-2" v-if="hasSupplier">
        <div class="box">
          <p class="text-lg text-theme-darker light:text-theme-lighter my-4 border-b border-theme-200 light:border-theme-600">
            Supplier account
          </p>
          <p class="text-xs">
            #{{ product.supplier_account.id }}
          </p>

          <p class="font-bold">
            {{ product.supplier_account.name }}
          </p>
          <p class="text-sm">
            {{ product.supplier_account.code }}
          </p>
        </div>
        <div class="box">
          <p class="text-lg text-theme-darker light:text-theme-lighter mb-4 border-b border-theme-200 light:border-theme-600">
            Supplier
          </p>
          <contact-information
            v-if="product.supplier_account.contact"
            :contact="product.supplier_account.contact"
            :contactType="product.supplier_account.contact.type"
            :link-to-contact="true"
            @updated="getProduct"
          ></contact-information>
        </div>
      </div>
      <div
        class="w-full px-2"
        :class="hasSupplier ? 'lg:w-2/3 xl:w-3/4' : ''"
      >
        <div class="box">
          <ul class="flex select-none mb-8">
            <li class="flex-1 mr-2">
              <a
                class="tab"
                :class="{ 'active': tabs.top.active === 'information' }"
                @click="tabs.top.active = 'information'"
                >
                Information
              </a>
            </li>
            <li class="flex-1">
              <a
                class="tab"
                  @click="openItemHistory"
                >
                Purchases/Sales History
              </a>
            </li>
          </ul>
          <div v-if="tabs.top.active === 'information'">
            <product-information
              :product="product"
              @updated="getProduct"
            />
            <product-statistics
              v-if="product && product.id"
              :productID="product.id"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import axios from 'axios'
const ContactInformation = resolve => require(['@/components/pages/ContactInformation'], resolve)
const ProductInformation = resolve => require(['@/components/pages/ProductInformation'], resolve)
const ProductStatistics = resolve => require(['@/components/pages/products/Statistics'], resolve)
const ItemHistory = resolve => require(['@/components/pages/invoices/ItemHistory'], resolve)

export default {
  components: {
    ContactInformation,
    ProductInformation,
    ProductStatistics,
    ItemHistory,
  },
  data() {
    return {
      productID: this.$route.params.productID,
      product: {},
      itemHistory: {
        active: false,
        product: {},
        type: 'purchases',
      },
      tabs: {
        top: {
          active: 'information',
        },
      },
    }
  },
  computed: {
    hasSupplier() {
      return this.product.supplier_account && this.product.supplier_account.contact
    }
  },
  mounted() {
    this.getProduct()
  },
  methods: {
    openItemHistory() {
      this.closeItemHistory()
      this.itemHistory.active = true
      this.itemHistory.product = this.product
    },
    closeItemHistory() {
      this.itemHistory.active = false
      this.itemHistory.product = {}
    },
    getProduct() {
      axios.get('products/' + this.productID)
        .then((response) => {
          const product = response.data
          this.product = Object.assign({}, product)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'Product not found',
            type: 'warning',
          })
            .then(() => {
              this.$router.push('/product/list')
            })
        })
    }
  }
}
</script>
